import { createContext, useContext } from "react";
import { TenantContext as TenantContextType } from "@/types/ai";
import { PrivateTenant } from "@/types/tenant";
export interface TenantContextValue {
  tenant: PrivateTenant | null;
  isLoading: boolean;
  tenantContext: TenantContextType | undefined;
  refetchTenant: () => Promise<PrivateTenant | null>;
}
export const TenantContext = createContext<TenantContextValue>({
  tenant: null,
  isLoading: false,
  tenantContext: undefined,
  refetchTenant: async () => null
});
export function useTenant() {
  const context = useContext(TenantContext);
  if (context === undefined) {
    throw new Error("useTenant must be used within a TenantProvider");
  }
  return context;
}